var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavByBusinessCapability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 85,
    viewBox: "0 0 70 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9226 16.1482H0V29.0988H15.9226V16.1482Z",
    fill: "#35A4E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0978 28.0195H1.06836V14.9148H17.0978V28.0195ZM1.17522 27.8654H16.991V15.069H1.17522V27.8654Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.8175 28.0195H18.7881V14.9148H34.8175V28.0195ZM18.8949 27.8654H34.7107V15.069H18.8949V27.8654Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.3215 13.6048H36.292V0.5H52.3215V13.6048ZM36.3989 13.4506H52.2146V0.654174H36.3989V13.4506Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.151 13.6048H1.12158V0.5H17.151V13.6048ZM1.22845 13.4506H17.0442V0.654174H1.22845V13.4506Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.8175 13.6048H18.7881V0.5H34.8175V13.6048ZM18.8949 13.4506H34.7107V0.654174H18.8949V13.4506Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M52.2682 42.4165H36.2388V29.3118H52.2682V42.4165ZM36.3456 42.2623H52.1614V29.4659H36.3456V42.2623Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.0978 42.4165H1.06836V29.3118H17.0978V42.4165ZM1.17522 42.2623H16.991V29.4659H1.17522V42.2623Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.7643 42.4165H18.7349V29.3118H34.7643V42.4165ZM18.8417 42.2623H34.6575V29.4659H18.8417V42.2623Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M52.3215 28.0195H36.292V14.9148H52.3215V28.0195ZM36.3989 27.8654H52.2146V15.069H36.3989V27.8654Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3949_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.8 13.6048H53.7705V0.5H69.8V13.6048ZM53.8774 13.4506H69.6931V0.654174H53.8774V13.4506Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M69.7477 42.4165H53.7183V29.3118H69.7477V42.4165ZM53.8251 42.2623H69.6409V29.4659H53.8251V42.2623Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M52.2682 56.7278H36.2388V43.623H52.2682V56.7278ZM36.3456 56.5736H52.1614V43.7772H36.3456V56.5736Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17.0978 56.7278H1.06836V43.623H17.0978V56.7278ZM1.17522 56.5736H16.991V43.7772H1.17522V56.5736Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M34.7643 56.7278H18.7349V43.623H34.7643V56.7278ZM18.8417 56.5736H34.6575V43.7772H18.8417V56.5736Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M69.7477 56.7278H53.7183V43.623H69.7477V56.7278ZM53.8251 56.5736H69.6409V43.7772H53.8251V56.5736Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M69.8 28.0195H53.7705V14.9148H69.8V28.0195ZM53.8774 27.8654H69.6931V15.069H53.8774V27.8654Z",
    fill: "#585860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M43.8197 84.5H1.24212C1.21248 84.5 1.18406 84.4858 1.1631 84.4604C1.14214 84.435 1.13037 84.4006 1.13037 84.3648C1.13037 84.3289 1.14214 84.2945 1.1631 84.2691C1.18406 84.2437 1.21248 84.2295 1.24212 84.2295H43.8197C43.8494 84.2295 43.8778 84.2437 43.8987 84.2691C43.9197 84.2945 43.9315 84.3289 43.9315 84.3648C43.9315 84.4006 43.9197 84.435 43.8987 84.4604C43.8778 84.4858 43.8494 84.5 43.8197 84.5Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M27.897 52.5412C27.9066 52.2967 27.9604 52.0577 28.0545 51.841C28.1487 51.6243 28.2809 51.4352 28.442 51.2871C28.603 51.139 28.7889 51.0354 28.9866 50.9837C29.1843 50.9319 29.389 50.9333 29.5862 50.9876L31.4158 47.8667L33.2539 48.7499L30.619 53.1134C30.5216 53.5083 30.3079 53.8463 30.0183 54.0633C29.7288 54.2803 29.3836 54.3612 29.0481 54.2907C28.7125 54.2202 28.4101 54.0031 28.1979 53.6807C27.9858 53.3582 27.8787 52.9528 27.897 52.5412L27.897 52.5412Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M29.9033 49.8573L33.1563 43.2351L31.831 38.9573L33.636 33.1309L33.7026 33.1654C33.7462 33.1881 34.7719 33.742 34.9239 35.7259L36.9982 43.6169L31.4621 52.31L29.9033 49.8573Z",
    fill: "#585860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.2366 25.5115C12.4373 25.542 12.63 25.6254 12.8012 25.7557C12.9724 25.8861 13.1179 26.0603 13.2275 26.2661C13.337 26.4719 13.408 26.7043 13.4353 26.9469C13.4626 27.1894 13.4457 27.4363 13.3857 27.6701L15.8149 30.1193L14.9453 32.2692L11.5549 28.7521C11.2371 28.604 10.9752 28.32 10.8188 27.9538C10.6625 27.5876 10.6226 27.1648 10.7066 26.7653C10.7906 26.3659 10.9928 26.0176 11.2748 25.7865C11.5568 25.5555 11.899 25.4576 12.2366 25.5115Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M14.2922 28.1414L19.4954 32.579L23.1215 31.3104L27.7811 33.9392L27.7475 34.0168C27.7255 34.0677 27.1899 35.2626 25.544 35.2927L18.8838 37.1858L12.1514 29.8328L14.2922 28.1414Z",
    fill: "#585860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M23.813 82.1053H22.0042L21.1436 73.6602L23.8133 73.6603L23.813 82.1053Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M20.1788 81.4792H24.2002V84.1379H18.5151V83.4929C18.5151 82.9589 18.6904 82.4467 19.0024 82.069C19.3144 81.6914 19.7376 81.4792 20.1788 81.4792Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M31.042 82.1053H29.233L28.3726 73.6602L31.0422 73.6603L31.042 82.1053Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M27.4092 81.4792H31.4307V84.1379H25.7456V83.4929C25.7456 82.9589 25.9209 82.4467 26.2329 82.069C26.5449 81.6914 26.968 81.4792 27.4092 81.4792Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M31.6864 51.2798L31.5389 63.7812L31.3913 80.2114L28.1453 79.8542L26.5223 57.1733L24.4567 79.8542H21.1056L20.7681 56.9948L21.9484 51.9941L31.6864 51.2798Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M21.6244 52.0701L21.1299 52.0442L23.4268 36.7285L22.4863 32.0992C22.4375 31.8584 22.4633 31.6042 22.5589 31.3848C22.6545 31.1655 22.8132 30.9962 23.0051 30.9091L24.6972 30.1411L25.295 28.1511L30.0117 28.7663L30.1277 30.3215C30.6388 30.5199 34.8477 32.2166 34.5573 34.1498C34.2707 36.0579 32.5783 42.0613 32.4923 42.3655L32.196 50.9751L32.1595 50.9971C32.1156 51.0237 28.8646 52.9586 25.3327 52.9582C24.089 52.9581 22.8097 52.7181 21.6244 52.0701Z",
    fill: "#585860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M30.4485 25.0279C31.3481 23.0359 30.7433 20.5383 29.0976 19.4494C27.4519 18.3605 25.3884 19.0926 24.4888 21.0846C23.5892 23.0766 24.194 25.5742 25.8397 26.6631C27.4854 27.752 29.5489 27.0199 30.4485 25.0279Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M30.2196 27.0352C29.5724 27.8696 28.3705 27.4217 28.2861 26.2817C28.2795 26.1932 28.28 26.1041 28.2876 26.0157C28.3311 25.5107 28.5721 25.0523 28.5144 24.5191C28.5013 24.3864 28.4605 24.26 28.3957 24.1517C27.88 23.3158 26.6693 24.5256 26.1826 23.7689C25.8841 23.3049 26.235 22.5743 26.0059 22.0557C25.7037 21.3712 24.8083 21.7088 24.2468 21.334C23.6221 20.9169 23.6595 19.7568 24.0707 19.0511C24.5722 18.1905 25.4515 17.7313 26.3199 17.6651C27.1882 17.5989 28.0506 17.8831 28.8613 18.2655C29.7824 18.7 30.6958 19.3004 31.2626 20.2808C31.9519 21.473 32.0183 23.0758 31.6735 24.4698C31.4638 25.3178 30.7481 26.3537 30.2196 27.0352Z",
    fill: "#2F2E41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavByBusinessCapability);
export default __webpack_public_path__ + "static/media/nav-by-business-capability.3969aa3e25d5dd1ed4016790de490bef.svg";
export { ForwardRef as ReactComponent };